import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";

const blank = (value) => {
  return (value !== undefined)? value: ''
}

const findIndex = (values, val) => {
  if (val !== undefined){
    for (let i = 0; i < values.length; i++) {
      if (values[i].value === val) return values[i].name
    }
  }
  return undefined
}

class panelContact extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].resume.contactinformation
    const {prefixes} = languages[langUrl]

    const values = this.props.data['contact']

    return (
      <div className='row resume-contact'>
        <div className='col-md-12 no-padding'>
          <div className='separating-line margin-top-50'><hr/></div>
          <div className='section-title'>{langPlace.title}</div>

          <div className='cuadre-height cuadre-principal'>
            <div className='cuadre-title'>{langPlace.namesurname}</div>
            <div className='cuadre-subtitle'>{`${blank(values.name)} ${blank(values.surname)} ${blank(values.secondSurname)}`}</div>
          </div>

          <div className='col-md-4 no-padding'>
            <div className='cuadre-height cuadre-secondary'>
              <div className='cuadre-title'>{langPlace.passport}</div>
              <div className='cuadre-subtitle'>{values.numberDocument}</div>
            </div>
          </div>
          <div className='col-md-8 no-padding'>
            <div className='cuadre-height cuadre-secondary'>
              <div className='cuadre-title'>{langPlace.phone}</div>
              <div className='cuadre-subtitle'>{`${blank(findIndex(prefixes, values.prefix))} ${blank(values.phone)}`}</div>
            </div>
          </div>
          <div className='col-md-8 col-sm-12 no-padding'>
            <div className='cuadre-height cuadre-secondary'>
              <div className='cuadre-title'>{langPlace.email}</div>
              <div className='cuadre-subtitle'>{values.email}</div>
            </div>
          </div>
          <div className='col-md-4 col-sm-12 no-padding'>
            <div className='cuadre-height cuadre-secondary'>
              <div className='cuadre-title'>{langPlace.postalCode}</div>
              <div className='cuadre-subtitle'>{values.postalcode}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data})
)(panelContact)



// WEBPACK FOOTER //
// ./src/shared/routes/routeResume/components/panelBooking.js